module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'active': _vm.active
    },
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "filterScroll"
  }, [_c('div', {
    staticClass: "filterList"
  }, [_c('h3', [_vm._v("Regions")]), _vm._v(" "), _c('ul', _vm._l((_vm.regions), function(region) {
    return _c('li', {
      attrs: {
        "track-by": "$index"
      }
    }, [_c('span', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'region_' + region.name
      },
      domProps: {
        "checked": region.value
      },
      on: {
        "change": function($event) {
          _vm.updateRegion(region)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'region_' + region.name
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "filterLabel",
      attrs: {
        "for": 'region_' + region.name
      }
    }, [_vm._v(_vm._s(_vm._f("slugToName")(region.name)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "filterList"
  }, [_c('h3', [_vm._v("Type")]), _vm._v(" "), _c('ul', _vm._l((_vm.types), function(type) {
    return _c('li', [_c('span', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'type_' + type.name
      },
      domProps: {
        "checked": type.value
      },
      on: {
        "change": function($event) {
          _vm.updateType(type)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'type_' + type.name
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "filterLabel",
      attrs: {
        "for": 'type_' + type.name
      }
    }, [_vm._v(_vm._s(_vm._f("slugToName")(type.name)))])])
  }))])]), _vm._v(" "), _c('a', {
    staticClass: "filters-btn",
    on: {
      "click": function($event) {
        _vm.toggleFilters()
      }
    }
  }, [_vm._m(0), _c('span', {
    staticClass: "text"
  }, [_vm._v("Filters")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-filter"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8733826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filters.vue
// module id = 445
// module chunks = 1